import { get, writable } from 'svelte/store';
import { TransportDocumentService } from '../../services/transport-document.service';
export const filterTransportDocumentId = writable(0);
export const loading = writable(false);
export const editing = writable(false);
export const records = writable([]);
//export const pagination = writable<IApiPagination | null>(null);
export const record = writable(null);
export async function initList(transportDocumentId) {
    //pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    filterTransportDocumentId.set(transportDocumentId);
    await load();
    initDetail();
}
export async function initDetail() {
    editing.set(false);
    record.set({
        oid: 0,
        transportDocumentId: get(filterTransportDocumentId),
        slaughterItemId: 0,
        sectionItemId: 0,
        productTypeId: 0,
        lotNumber: "",
        quantity: 0,
        unit: "NR",
        realWeight: 0.0,
        weight: 0.0,
        clfProcessingTypeId: null,
        recipeId: null
    });
}
export async function search() {
    //pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    editing.set(false);
    try {
        let _transportDocumentId = get(filterTransportDocumentId);
        //let _pag = get(pagination)!;
        //let _resp = await SlaughterService.getSlaughterItems(_slaughterId, _pag.currentPage);
        let _resp = await TransportDocumentService.getTransportDocumentItems(_transportDocumentId);
        records.set(_resp.payload);
        //pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    // console.log("onCreate");
}
export function onEdit(item) {
    // console.log("onEdit", item);
    record.set(item.transportDocumentItem);
    editing.set(true);
}
export async function save() {
    let _record = get(record);
    editing.set(false);
    return await TransportDocumentService.saveTransportDocumentItem(_record);
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await TransportDocumentService.deleteTransportDocumentItem(item.oid);
    await load();
}
// export function onPageChange(pageNumber: number) {
//   // console.log("onPageChange: " + pageNumber);
//   pagination.set({ ...get(pagination)!, currentPage: pageNumber });
//   load();
// }
